import { useMemo } from "react";
import { shallow } from "zustand/shallow";
import { useAccountStore } from "@core/stores/accountStore";
import { useAuthStore } from "@core/stores/authStore";
import { ChevronDown } from "lucide-react";
import PartnerSvg from "@/assets/svg/header/icon-partner.svg?react";
import PartnerActiveSvg from "@/assets/svg/header/icon-partner-active.svg?react";

import ICafeList from "@features/account/components/iCafe/ICafeList";

function PartnerIcon({ isPartner }: { isPartner: boolean }) {
  return <div className="flex h-[24px] w-[24px] items-center justify-center rounded-full bg-gray-100">{isPartner ? <PartnerActiveSvg /> : <PartnerSvg />}</div>;
}

function UserInfo({ personName, iCafeName }: { personName: string; iCafeName: string }) {
  return (
    <dl>
      <dt className="text-lg font-medium whitespace-nowrap text-gray-700">{personName} 사장님</dt>
      <dd className="text-md text-point-600 line-clamp-1 max-w-[100px] break-all">{iCafeName ? `(${iCafeName})` : ""}</dd>
    </dl>
  );
}

export default function UserPc() {
  const account = useAccountStore((state) => state.account);
  const { primaryICafeId, iCafeList, loginICafeInfo } = useAuthStore(
    (state) => ({
      isLogin: state.isLogin,
      auth: state.auth,
      primaryICafeId: state.primaryICafeId,
      iCafeList: state.iCafeList,
      loginICafeInfo: state.loginICafeInfo,
    }),
    shallow,
  );
  const personName = useMemo(() => {
    return account?.ncfzPlayncUserInfo?.personName ?? "";
  }, [account]);
  const iCafeName = useMemo(() => {
    return iCafeList?.find((item) => item.iCafeId === primaryICafeId)?.companyFullName ?? "";
  }, [iCafeList, primaryICafeId]);

  return (
    <ICafeList useAccountUserButton={true}>
      <div className="flex h-[60px] min-w-[194px] cursor-pointer items-center gap-[6px] rounded-lg bg-gray-100 px-[20px]">
        <PartnerIcon isPartner={loginICafeInfo?.smartICafe ?? false} />
        <UserInfo {...{ personName, iCafeName }} />
        <ChevronDown />
      </div>
    </ICafeList>
  );
}
